module.exports = __webpack_public_path__ + "img/tigerflo.e3c8450e.png";